import { SIZE_10MO_OCTETS, useTextes } from '@common/config';
import { Z_ID, Z_SAVED_FILE, Z_TEXT } from '@common/schemas';
import { z } from 'zod';

const t = useTextes('Commun', 'PopupEtab');
const MAX_SIZE_NAME_TEXT = 300;
const MAX_SIZE_CORPS_TEXT = 1024;


export const editMotifMailFormSchema = (nomsMotifsDejaUtilises: string[]) => z.object({
  id: Z_ID.optional().readonly(),
  categorie: Z_TEXT().readonly(),
  corps: Z_TEXT().max(MAX_SIZE_CORPS_TEXT, { error: `La taille du texte est supérieure à la limite autorisée de ${MAX_SIZE_CORPS_TEXT} caractères` }),
  sujet: Z_TEXT().max(MAX_SIZE_NAME_TEXT, { error: `La taille du texte est supérieure à la limite autorisée de ${MAX_SIZE_NAME_TEXT} caractères` }),
  nom: Z_TEXT()
    .max(MAX_SIZE_NAME_TEXT, { error: `La taille du texte est supérieure à la limite autorisée de ${MAX_SIZE_NAME_TEXT} caractères` })
    .refine((valeurSaisie) => !nomsMotifsDejaUtilises.includes(valeurSaisie), {
      error: 'Ce nom de motif est déja utilisé',
    }),
  fichier: Z_SAVED_FILE({ errorMsg: t['DEPOT_FICHIER_TEXTE1'], maxSize: SIZE_10MO_OCTETS }).nullable(),
});

export type EditMotifMailFormSchema = z.infer<ReturnType<typeof editMotifMailFormSchema>>